import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ReplayIcon from '@mui/icons-material/Replay';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import availabilityTime from '../../../utils/availabilityTime';

const Availabiity = ({ className }) => {
  const [time, setTime] = React.useState(1800);

  const handleChange = (event) => {
    setTime(event.target.value);
  };

  return (
    <div className={className}>
      <div className="container">
        <p>
          Je suis disponible pendant
          <span className="primaryPeach"> 39 min </span>
          pour offrir Alphonse à quelqu&apos;un
        </p>
      </div>
      <div className="time__container">
        <InputLabel id="demo-simple-select-label">Time</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          className="select"
          value={time}
          label="Time"
          onChange={handleChange}
        >
          {availabilityTime.map(({ value, text }) => (
            <MenuItem key={value} value={value} className="menuItem">
              {text}
            </MenuItem>
          ))}
        </Select>
        <div className="replay">
          <ReplayIcon fontSize="small" className="replay__icon" />
        </div>
      </div>
    </div>
  );
};

Availabiity.propTypes = { className: PropTypes.string.isRequired };

export default styled(Availabiity)`
  display: flex;
  border-radius: 0.5rem;
  border: 1px solid gray;
  padding: 0.5rem;
  margin: 1rem 0;

  .container {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 1rem;
  }

  .time__container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .select {
    color: hsl(0, 79%, 72%);
    background: hsl(9, 48%, 95%);
  }

  p {
    width: 95%;
  }

  .menuItem {
    color: hsl(60, 1%, 74%);
  }

  .replay {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    width: 2rem;
    height: 2rem;
    margin: 0.5rem;
    background-color: hsl(9, 48%, 95%);
    &__icon {
      color: hsl(0, 79%, 72%);
    }
  }
`;
